import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useCustomer } from '../../Context/Customer/CustomerContext';
import { useBookingTimer } from '../../Context/Timer/useBookingTimer';
import { useBookingSession } from '../../Context/BookingSession/BookingSessionContext';
import { canSkipBookingVerification } from '../../Utils/bookingVerification';

export const SkipActiveBookingVerification = ({ children }) => {
  const { bookingID } = useBookingSession();
  const { formData, isUserVerified, verifiedMobile } = useCustomer();
  const { isTimerActive, isTimesup, timeLeft } = useBookingTimer();
  const canSkip = Boolean(bookingID) && canSkipBookingVerification({
    isTimerActive, isTimesup, timeLeft, isUserVerified, verifiedMobile,
    currentMobile: formData.mobile,
  });
  // Only skip on entry. Do not interrupt OTP's in-flight booking update when
  // verification succeeds; that page completes its request before navigating.
  const [verifiedOnEntry] = useState(canSkip);

  if (verifiedOnEntry && canSkip) return <Navigate to="/contact-details" replace />;
  return children;
};
